import React from 'react';
import PropTypes from 'prop-types';
import { FormAutosuggest, FormAutosuggestOption, FormControlFeedback } from '@openedx/paragon';

const SectorField = ({ sectorList, value, errorMessage, handleChange, handleErrorChange, floatingLabel }) => {
  // Convert string options to objects for FormAutosuggest
  const options = sectorList.map((sector) => ({
    id: sector, // Unique identifier
    label: sector, // Display text
  }));

  // Convert the current string value to the expected object format
  // const selectedOption = options.find((option) => option.id === value) || null;

  // Handle changes from FormAutosuggest
  // const handleOnChange = (selectedOption) => {
  //   console.log('Option',selectedOption)
  //   handleChange({ target: { name: 'sector', value: selectedOption?.selectionValue || '' } });
  // };

  const handleOnChange = (selectedOption) => {
    // Pass back the selected option object
    handleChange({ target: { name: 'sector', value: selectedOption || null } });
  };

  const handleOnFocus = () => {
    handleErrorChange('sector', '');
    handleChange({ target: { name: 'sector', value: null } });
  };


  return (
    <div className="mb-4">
     <FormAutosuggest
  floatingLabel={floatingLabel}
  aria-label="sector autosuggest"
  name="sector"
  value={value || {}} // Provide a default empty object if value is null
  className={errorMessage ? 'form-field-error' : ''}
  onFocus={handleOnFocus}
  onChange={handleOnChange}
  // readOnly={true}
>
  {options.map((option) => (
    <FormAutosuggestOption key={option.id} id={option.id}>
      {option.label}
    </FormAutosuggestOption>
  ))}
</FormAutosuggest>
      {errorMessage && (
        <FormControlFeedback
          key="error"
          className="form-text-size"
          hasIcon={false}
          feedback-for="sector"
          type="invalid"
        >
          {errorMessage}
        </FormControlFeedback>
      )}
    </div>
  );
};

SectorField.defaultProps = {
  errorMessage: '',
  floatingLabel: 'Sector',
};

SectorField.propTypes = {
  sectorList: PropTypes.arrayOf(PropTypes.string).isRequired, // Array of strings
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired, // Allow both string and object
  errorMessage: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
  floatingLabel: PropTypes.string,
};

export default SectorField;
